// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-content-wrapperMobile-onncs{overflow:hidden;padding-top:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperMobile": "components-pages-content-wrapperMobile-onncs"
};
module.exports = ___CSS_LOADER_EXPORT___;
